import { createStore, applyMiddleware, combineReducers } from 'redux';
import ReduxThunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension';
import { sideBarReducerGenerator } from '@bento-core/facet-filter';
import layout from '../components/Layout/LayoutState';
import stats from '../components/Stats/StatsState';
import inventoryReducer from '../components/Inventory/InventoryState';
import { cartReducerGenerator } from '@bento-core/cart';
import { LocalFindReducerGenerator } from '@bento-core/local-find';
import cohortAnalyzerLayout from '../pages/CohortAnalyzer/store/cohortAnalyzerLayoutReducer';

const { localFind } = LocalFindReducerGenerator();
const { statusReducer } = sideBarReducerGenerator();
const { cartReducer } = cartReducerGenerator();

const reducers = {
  localFind,
  inventoryReducer,
  cartReducer,
  statusReducer,
  layout,
  stats,
  cohortAnalyzerLayout,
};
const loggerMiddleware = createLogger();

let store;
if (process.env.NODE_ENV === 'development') {
  store = createStore(
    combineReducers(reducers),
    composeWithDevTools(applyMiddleware(ReduxThunk, loggerMiddleware)),
  );
} else {
  store = createStore(
    combineReducers(reducers),
    applyMiddleware(ReduxThunk)
  );
}

store.injectReducer = (key, reducer) => {
  reducers[key] = reducer;
  store.replaceReducer(combineReducers(reducers));
};

export default store;

